const menuItems = [
  { name: 'Main', to: '/', end: true },
  { name: 'Planning', to: '/planning', end: false },
  { name: 'Awards', to: '/awards', end: false },
  { name: 'Contacts', to: '/contacts', end: false },
];

export default menuItems;
